module.exports = __webpack_public_path__ + "img/位图.bc1d250d.png";